import NodeEvents from 'events';
import * as Inovx from '@shared';
import HomeConstants from '../constants/HomeConstants';
import type { IHomeKnowledgeBook } from '../constants/interfaces';

const EventEmitter = NodeEvents.EventEmitter;
const CHANGE_EVENT = 'HomeKnowledgeBook.change';

let _recentKnowledgeBooks: IHomeKnowledgeBook[] = [];
let _favoriteKnowledgeBooks: IHomeKnowledgeBook[] = [];

const HomeKnowledgeBookStore = Object.assign({}, EventEmitter.prototype, {
    getRecentOpenedKnowledgeBooks(): IHomeKnowledgeBook[] {
        return _recentKnowledgeBooks;
    },
    getFavoriteKnowledgeBooks(): IHomeKnowledgeBook[] {
        return _favoriteKnowledgeBooks;
    },
    emitChange() {
        this.emit(CHANGE_EVENT);
    },
    addChangeListener(callback: () => void) {
        this.on(CHANGE_EVENT, callback);
    },
    removeChangeListener(callback: () => void) {
        this.removeListener(CHANGE_EVENT, callback);
    },
});

Inovx.Shared.Flux.AppDispatcher.register((payload: any) => {
    switch (payload.actionType) {
        case HomeConstants.HOME_KB_GET_RECENT:
            _recentKnowledgeBooks = payload.data ?? [];
            HomeKnowledgeBookStore.emitChange();
            break;
        case HomeConstants.HOME_KB_GET_FAVORITES:
            _favoriteKnowledgeBooks = payload.data ?? [];
            HomeKnowledgeBookStore.emitChange();
            break;
    }
    return true;
});

export default HomeKnowledgeBookStore;
